import React from 'react';
import { connect } from 'react-redux';
import { Card } from 'react-bootstrap';
import PropertyPickerVertical from './components/PropertyPickerVertical';
import BaseFeature from './BaseFeature';
import { MODULE_ARCHITECTURE } from '../../../../../../utils/constantFeatures';

class ModuleArchitecture extends BaseFeature {

    constructor() {
        super();

        this.state = {};
        
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {

        this.props.handleChange(propertyName, value);
    }

    render() {
        
        const numberOfLedStringsCh0 = this.props.properties[MODULE_ARCHITECTURE.numberOfLedStringsCh0];
        const numberOfLedStringsCh1 = this.props.properties[MODULE_ARCHITECTURE.numberOfLedStringsCh1];
        const numberOfLedsPerStringsCh0 = this.props.properties[MODULE_ARCHITECTURE.numberOfLedsPerStringsCh0];
        const numberOfLedsPerStringsCh1 = this.props.properties[MODULE_ARCHITECTURE.numberOfLedsPerStringsCh1];

        console.log(this.props.properties);

        return (
            <div>
                <div className="flex-row" style={{ paddingTop: '0.75rem' }}>
                    <Card className={this.getClassName([numberOfLedStringsCh0, numberOfLedsPerStringsCh0])}>
                        <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                            {'Cold White CH1'}
                        </div>
                        <Card.Body style={{ display: "flex" }} disabled={!this.state.isEnabled}>
                            <PropertyPickerVertical
                                property={numberOfLedStringsCh0}
                                border={'border-none'}
                                title={"Number of LED strings"}
                                measureUnit={numberOfLedStringsCh0.info.unit}
                                min={numberOfLedStringsCh0.valueMeta.min}
                                max={numberOfLedStringsCh0.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                property={numberOfLedsPerStringsCh0}
                                border={'left'}
                                title={"Number of LEDs per string"}
                                measureUnit={numberOfLedsPerStringsCh0.info.unit}
                                min={numberOfLedsPerStringsCh0.valueMeta.min}
                                max={numberOfLedsPerStringsCh0.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </div>

                <div className="flex-row" style={{ paddingTop: '0.75rem' }}>
                    <Card className={this.getClassName([numberOfLedStringsCh1, numberOfLedsPerStringsCh1])}>
                        <div className="card-header-feature" style={{ margin: "-1rem auto 0" }}>
                            {'Warm White CH2'}
                        </div>
                        <Card.Body style={{ display: "flex" }} disabled={!this.state.isEnabled}>
                            <PropertyPickerVertical
                                property={numberOfLedStringsCh1}
                                border={'border-none'}
                                title={"Number of LED strings"}
                                measureUnit={numberOfLedStringsCh1.info.unit}
                                min={numberOfLedStringsCh1.valueMeta.min}
                                max={numberOfLedStringsCh1.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            <PropertyPickerVertical
                                property={numberOfLedsPerStringsCh1}
                                border={'left'}
                                title={"Number of LEDs per string"}
                                measureUnit={numberOfLedsPerStringsCh1.info.unit}
                                min={numberOfLedsPerStringsCh1.valueMeta.min}
                                max={numberOfLedsPerStringsCh1.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ModuleArchitecture);